export function makeFactAddressItems(data) {
    const cityFact = data?.attendance?.data ?? {};

    return [
        {
            label: "Local pré-cadastrado",
            value: cityFact?.attendance_factplace ?? "",
        },
        {
            label: "Tipo",
            value: cityFact?.attendance_facttype ?? "",
        },
        {
            label: "Logradouro",
            value: cityFact?.attendance_factstreet ?? "",
        },
        {
            label: "Número",
            value: cityFact?.attendance_factnumber ?? "",
        },
        {
            label: "Bairro",
            value: cityFact?.attendance_factneighborhood ?? "",
        },
        {
            label: "Cruzamento",
            value: cityFact?.attendance_factcrossroads ?? "",
        },
        {
            label: "Ponto de referência",
            value: cityFact?.attendance_factreferencepoint ?? "",
        },
        {
            label: "Município",
            value: cityFact?.attendance_factcity ?? "",
        },
        {
            label: "Setores",
            value: cityFact?.attendance_sector ?? "",
        },
    ];
}